import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NoticeSeverity = DatabaseCode;

const info: NoticeSeverity = {
  code: "INFO",
  displayValue: {
    id: "common.entity.noticeseverity.info",
    defaultMessage: "Info",
  },
};

const major: NoticeSeverity = {
  code: "MAJOR",
  displayValue: {
    id: "common.entity.noticeseverity.major",
    defaultMessage: "Major",
  },
};

const critical: NoticeSeverity = {
  code: "CRITICAL",
  displayValue: {
    id: "common.entity.noticeseverity.critical",
    defaultMessage: "Critical",
  },
};

export const noticeSeverity = {
  info,
  major,
  critical,
};

export const noticeSeverities = Object.values(noticeSeverity);

export const toNoticeSeverity = (code: string): NoticeSeverity =>
  toDatabaseCode(code, noticeSeverities);

export const toNoticeSeveritySafely = (
  code: string | undefined
): NoticeSeverity | undefined =>
  code ? toDatabaseCode(code, noticeSeverities) : undefined;
